export const indexById = <T extends { id: string }>(items: T[]): Map<string, T> =>
  new Map(items.map((item) => [item.id, item]));

export const groupByReadingId = <T extends { readingId: string }>(items: T[]): Map<string, T[]> => {
  const groups = new Map<string, T[]>();
  for (const item of items) {
    const group = groups.get(item.readingId) ?? [];
    group.push(item);
    groups.set(item.readingId, group);
  }
  return groups;
};
